import { render } from "./SubscribeButton.vue?vue&type=template&id=3cf4a61a"
import script from "./SubscribeButton.vue?vue&type=script&lang=ts"
export * from "./SubscribeButton.vue?vue&type=script&lang=ts"
script.render = render

export default script